import React from 'react'
import { initializeApollo } from '@gql/client'
import { PaginaDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import AdesioneB2CTemplate from '@components/templates/AdesioneB2CTemplate/AdesioneB2CTemplate'

const AdesioneB2CPagina = ({ pagina }) => {
  return <AdesioneB2CTemplate pagina={pagina} />
}

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ preview, previewData, locale }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'adesione-B2C', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { pagina },
      revalidate: 60 * 20,
    }
  },
  'adesione-B2C'
)

export default AdesioneB2CPagina
